<template>
  <div class="offer-banner">
    <span class="offer-banner_value">
      <slot name="value"></slot>
    </span>
    <p class="offer-banner_text">
      <slot></slot>
    </p>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component
class OfferBanner extends Vue {

}

export default OfferBanner
</script>

<style lang="scss" src="./styles/offer-banner.scss"></style>
